import {SEARCH_KEYWORD, SEARCH_CLOSE_KEYWORD, SEARCH_CLOSE_KEYWORD_ERR, SEARCH_RESULT, SEARCH_RESULT_ERR} from '../actions/search/type';

const initState = {keyword: null, searchResult: null, countSearchResult: 0, searchErr: null, listCloseTerms: null};
export default function(state = initState, action) {
    switch (action.type) {
        case SEARCH_CLOSE_KEYWORD: 
            return {...state, listCloseTerms: action.payload};
        case SEARCH_CLOSE_KEYWORD_ERR:
            return {...state, listCloseTerms: [], listCloseTermErr: action.payload};
        case SEARCH_KEYWORD:
            return {...state, keyword: action.payload};
        case SEARCH_RESULT:
            const data = action.payload? action.payload.data: [];
            const count = action.payload? action.payload.count: 0;
            return {...state, searchResult: data, countSearchResult: count};
        case SEARCH_RESULT_ERR: 
            return {...state, searchErr: action.payload, searchResult: null, countSearchResult: 0}
        default: 
            return {...state};
    }
}